import React, { Component } from 'react'
import { Modal, Radio } from 'antd'
import { StyledCard } from './styled'
import { UppercaseP } from 'Common/styled'

import { handleAgreementPm, handleAgreementSupplier, userType } from 'Common/constants'
import { renderRadios } from 'Common/utils'

class HandleAgreementModal extends Component {
  state = {
    selected: null
  }
  render() {
    const { user } = this.props
    const { selected } = this.state
    return (
      <Modal
        width={800}
        visible={this.props.visible}
        okText="Salva"
        cancelText="Annulla"
        onOk={() => this.props.onOkCallback(selected)}
        onCancel={this.props.onCancelCallback}
        // If nothing is selected, disable save button
        okButtonProps={{ disabled: !selected }}>
        <StyledCard>
          <UppercaseP>
            <strong>Tipologia di reso:</strong>
          </UppercaseP>
          <p>
            <u>Reso per Accredito (a stesso Fornitore):</u> il Fornitore
            procederà all’emissione della relativa nota di credito al
            ricevimento dei resi merce spediti per il valore pari al prezzo di
            seguito indicato. La nota di credito da parte del Fornitore dovrà
            pervenire a LMIT entro 30 giorni dalla ricezione dei prodotti resi.
          </p>
          <p>
            <u>Fatturazione del reso ( a Fornitore diverso):</u> LMIT procederà
            all’emissione della relativa fattura alla data di presa in carico
            della merce da parte del vettore. Il pagamento della stessa avverrà
            per compensazione entro 30 giorni dall’emissione della stessa.
          </p>
          <UppercaseP>
            <strong>Quantità:</strong>
          </UppercaseP>
          <p>
            Le quantità specificate sono da intendersi meramente indicative.
            L’ammontare specifico oggetto del presente accordo verrà esplicitato
            dal Capo Settore nella proposta di reso del Punto Vendita.
          </p>
          <UppercaseP>
            <strong>Organizzazione e spese di trasporto</strong>
          </UppercaseP>
          <p>
            <u>A carico di LMIT:</u> LMIT porrà in essere tutte le operazioni
            necessarie all’organizzazione e trasporto dei resi c/o la sede
            indicata dal Fornitore. Le spese sostenute verranno integralmente
            addebitate al Fornitore secondo le tariffe e con le modalità
            concordate tra il Capo Prodotto e il Fornitore.
          </p>
          <p>
            <u>A carico del Fornitore:</u> il Fornitore previo appuntamento con
            la logistica di negozio, provvede al ritiro del reso dal Punto
            Vendita a sue spese. Se entro 30 giorni dal termine della validità
            dell’accordo quadro, il Fornitore non ha provveduto al ritiro del
            reso, questo sarà inviato da LM e rifatturate le spese di trasporto.
          </p>
          <UppercaseP>
            <strong>Mancato ritiro del reso</strong>
          </UppercaseP>
          <p>
            Fatto salvo il compenso correlato al preventivo di spesa per il reso
            che il Fornitore ha espressamente accettato, quest’ultimo ha facoltà
            di non ritirare i resi oggetto del presente Accordo Quadro, che
            rimarranno nella piena disponibilità del Punto Vendita LMIT, dandone
            comunicazione al Capo Settore nell’ambito della proposta di reso del
            Punto Vendita. Nell’ipotesi sopra specificata, il Fornitore
            autorizza LMIT a gestire lo smaltimento dei prodotti resi e/o
            l’eventuale ulteriore destinazione che LMIT vorrà dare ai prodotti
            in questione. In caso di necessità di documento di uscita del reso,
            il Fornitore è tenuto a farne richiesta scritta sulla proposta di
            reso. Il Punto Vendita lo invierà al Fornitore subito dopo
            l’emissione.
          </p>
        </StyledCard>
        <Radio.Group
          id="handleAgreementRadio"
          onChange={e => this.setState({ selected: e.target.value })}>
          {user.type === userType.S.key
            ? renderRadios(handleAgreementSupplier)
            : renderRadios(handleAgreementPm)}
        </Radio.Group>
      </Modal>
    )
  }
}
export default HandleAgreementModal



// WEBPACK FOOTER //
// ./src/components/HandleAgreementModal/index.js